<template>
  <div>
    <div>
      <input v-model="innerUsername" class="outlined" placeholder="Username">
    </div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'change-username-form',
  props: ['payload', 'username'],
  data () {
    return {
      innerUsername: this.username,
      is_loading: false
    }
  },
  methods: {
    submit () {
      if (this.innerUsername.length < 0) {
        this.$utils.emit('show_toast', { text: 'אנא הקלד/י לפחות כמה תווים' })
        return
      }
      if (!confirm("Are you sure you want to change this user's username?")) {
        return
      }
      this.is_loading = true
      this.$network_utils.updateUser({ user_id: this.payload.user_id, username: this.innerUsername }).then(() => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'שם משתמש שונה בהצלחה!' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
